const requestAppointmentLinkBuilder = (permalink) =>
  `${permalink}#request-appointment`;

export default requestAppointmentLinkBuilder;
